const AddressView = r => require.ensure([], () => r(require('./AddressView.vue')), 'shared')
const AddressListGoogle = r => require.ensure([], () => r(require('./AddressListGoogle.vue')), 'shared')
const AddressListMapbox = r => require.ensure([], () => r(require('./AddressListMapbox.vue')), 'shared')
const GoogleSuburbAutocomplete = r => require.ensure([], () => r(require('./GoogleSuburbAutocomplete.vue')), 'shared')
const MapboxSuburbAutocomplete = r => require.ensure([], () => r(require('./MapboxSuburbAutocomplete.vue')), 'shared')

export { AddressView, AddressListGoogle, AddressListMapbox, GoogleSuburbAutocomplete, MapboxSuburbAutocomplete }
